import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  licenseType: {
    id: 'course-authoring.schedule-section.license.type',
    defaultMessage: 'License type',
  },
  licenseChoice1: {
    id: 'course-authoring.schedule-section.license.choice-1',
    defaultMessage: 'All rights reserved',
  },
  licenseChoice2: {
    id: 'course-authoring.schedule-section.license.choice-2',
    defaultMessage: 'Creative commons',
  },
  licenseTooltip1: {
    id: 'course-authoring.schedule-section.license.tooltip-1',
    defaultMessage: 'You reserve all rights for your work',
  },
  licenseTooltip2: {
    id: 'course-authoring.schedule-section.license.tooltip-2',
    defaultMessage: 'You waive some rights for your work, such that others can use it too',
  },
  creativeCommonsURLParagraph: {
    id: 'course-authoring.schedule-section.license.creative-commons.url',
    defaultMessage: 'Learn more about creative commons',
  },
});

export default messages;
